<template>
  <v-card outlined>
    <v-card-title class="d-flex pa-1 bg">
      <div class="mr-auto d-flex">
        <span class="px-1">{{ $t(title) }}</span>
        <span class="px-1" v-show="existDutyNm">{{ `(${dutyItem.dutyNm})` }}</span>
      </div>
      <div v-if="mode == 'EDIT' && dutyId != 0" class="top-button-group">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-btn
              v-on="on" class="mr-2" x-small right color="primary"
              :disabled="dutyItem.isSstm == 1"
              @click="addDutyAuth"
            >
              <v-icon small>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('common.add') }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-text class="pa-0">
      <!-- eslint-disable-next-line prettier/prettier -->
      <v-data-table v-if="mode == 'LIST'"
        :headers="listHeaders" :items="items" item-key="authId" :loading="loading"
        class="elevation-1 content" :height="listModeDataTableHeight"
        fixed-header disable-pagination dense hide-default-footer
      />
      <!-- eslint-disable-next-line prettier/prettier -->
      <v-data-table v-if="mode == 'EDIT'"
        :headers="editHeaders" :items="items" item-key="authId" :loading="loading"
        class="elevation-1 content" :height="editModeDataTableHeight"
        fixed-header disable-pagination dense hide-default-footer single-select
        @click:row="highlight"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-icon
                v-on="on" small class="mr-2" color="primary"
                :disabled="dutyItem.isSstm == 1"
                @click="editDutyAuth(item)"
              >
                mdi-pencil-box-multiple-outline
              </v-icon>
            </template>
            <span>{{ $t('common.edit') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-icon
                v-on="on" small color="primary"
                :disabled="dutyItem.isSstm == 1"
                @click="deleteDutyAuth(item)"
              >
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>{{ $t('common.delete') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <duty-auth-form v-show="showForm" :auth-id="selectedId" :duty-id="dutyItem.dutyId" @close="closeForm" />
    </v-card-text>
  </v-card>
</template>

<script>
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
import DutyAuthForm from './DutyAuthForm.vue';

export default {
  components: {
    DutyAuthForm,
  },
  props: {
    title: {
      type: String,
    },
    mode: {
      type: String,
      required: true,
      default: 'LIST',
    },
    dutyId: {
      type: Number,
      required: true,
      default: 0,
    },
    height: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      showForm: false,
      showFormMode: '',
      selectedId: 0,
      dutyItem: { dutyNm: '' },
    };
  },
  computed: {
    listModeDataTableHeight() {
      // 20은 LIST 모드에서 <v-card-title>의 높이, 116은 DutyAuthForm의 높이. 마지막 수치는 보정치.
      return this.height - 20 - 10;
    },
    editModeDataTableHeight() {
      // 36는 EDIT 모드에서 <v-card-title>의 높이, 116은 DutyAuthForm의 높이.. 마지막 수치는 보정치.
      if (this.showForm) return this.height - 36 - 116 - 10;
      return this.height - 36 - 10;
    },
    existDutyNm() {
      return !isEmpty(this.dutyItem.dutyNm);
    },
    listHeaders() {
      return this.headers;
    },
    editHeaders() {
      return [].concat(this.headers, [{ text: '', value: 'actions', width: '74px', sortable: false, align: 'center' }]);
    },
    headers() {
      return [
        { text: this.$t('sod.ttl.id'), value: 'authId', width: '70px', sortable: false, align: 'right' },
        { text: this.$t('sod.ttl.auth.obj'), value: 'authObj', sortable: false },
        { text: this.$t('sod.ttl.auth.fld'), value: 'authFld', sortable: false },
        { text: this.$t('sod.ttl.auth.val'), value: 'authVal', sortable: false },
      ];
    },
  },
  watch: {
    dutyId: {
      handler() {
        this.showForm = false;
        this.fetchDuty();
        this.fetchDutyAuthList();
      },
    },
  },
  methods: {
    highlight(item, { isSelected, select }) {
      select(!isSelected);
      // 선택이 됐을 때.
      if (!isSelected) {
        this.selectedId = item.authId;
        /*
         * "edit" 버튼이 클릭됐을 때에도, data-table의 row가 선택된다.
         * 물론 "edit" 버튼의 @click 이벤트를 @click.stop 처리해주면 data-table의 row가 선택되는 행위는 발생하지 않는다.
         * 하지만, "edit" 버튼이 클릭됐을 때 해당 row가 선택되어야 한다.
         * 그러면서도, DutyAuthForm이 보여진 상태에서 다른 row가 선택되면 DutyAuthForm이 닫히게 하고 싶다.
         * 아래 두 줄은 그러한 로직을 구현한 것이다.
         * 참고로, this.showFormMode에 'EDIT'를 할당하는 행위는 "edit" 버튼이 클릭됐을 때 이루어진다.
         */
        if (this.showFormMode != 'EDIT') this.showForm = false;
        this.showFormMode = '';
      }
    },
    addDutyAuth() {
      this.selectedId = 0;
      this.showForm = true;
    },
    /**
     * selectedId가 DutyAuthForm에 props 'authId'로 전달되고,
     * DutyAuthForm은 props 'authId'가 변했을 때 반응하게 작성되었으므로,
     * selectedId가 변경되도록 0을 할당했다가 다시 선택된 authId를 할당해준다.
     */
    editDutyAuth(item) {
      this.selectedId = 0;
      // this.selectedId를 바로 바꾸어 주면
      // DutyAuthForm 쪽에서 watch 'authId'의 reactivity가 동작하지 않으므로
      // 약간의 delay를 준다.
      this.$nextTick(() => {
        this.selectedId = item.authId;
      });
      this.showFormMode = 'EDIT';
      this.showForm = true;
    },
    async deleteDutyAuth(item) {
      if (await this.$dialog.confirm(this.$t('common.delete.q'))) {
        const data = {
          authId: item.authId,
        };
        const { status } = await api.delete('/sod/duty-auth', { data });
        if (status === 200) {
          this.$dialog.info(this.$t('common.successful'));
          this.fetchDutyAuthList();
        }
      }
    },
    async closeForm(mode) {
      this.showForm = false;
      if (mode == 'save') await this.fetchDutyAuthList();
    },
    async fetchDuty() {
      if (this.dutyId == 0) {
        this.dutyItem = { dutyNm: '' };
        return;
      }
      const params = { dutyId: this.dutyId };
      const { data: item } = await api.get('/sod/duty', { params });
      this.dutyItem = item;
    },
    async fetchDutyAuthList() {
      if (this.dutyId == 0) {
        this.items = [];
        return;
      }
      const params = { dutyId: this.dutyId };
      const { data: items } = await api.get('/sod/duty-auth-list', { params });
      this.items = items;
    },
  },
  async created() {
    await this.fetchDutyAuthList();
  },
};
</script>
